import type { ProjectWithInterviewCount } from "@repo/app-types/entities/project";
import { InterviewAgentType } from "@repo/app-types/entities/project";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { Label } from "@repo/ui/Label/label";
import { IconCheck } from "@tabler/icons-react";
import copy from "copy-to-clipboard";
import type React from "react";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

interface InterviewLinkCopyboxProps {
  /** @deprecated Use for legacy UI only */
  className?: string;
  inviteLinkUrl: string;
  project: ProjectWithInterviewCount;
  onCopyInterviewLink: () => void;
  linkLabel: string;
}

export const InterviewLinkCopybox: React.FC<InterviewLinkCopyboxProps> = ({
  className,
  inviteLinkUrl,
  project,
  onCopyInterviewLink,
  linkLabel,
}) => {
  const [isCopyingInterviewLink, setIsCopyingInterviewLink] = useState(false);

  return (
    <div className={twMerge("flex flex-col justify-between", className)}>
      <Label size={Size.SMALL}>{linkLabel}</Label>
      <div className="mt-1 flex max-w-72 flex-row space-x-2">
        <Button
          variant={ButtonVariant.Secondary}
          onClick={() => {
            setIsCopyingInterviewLink(true);
            copy(inviteLinkUrl);

            setTimeout(() => {
              setIsCopyingInterviewLink(false);
            }, 4000);

            onCopyInterviewLink();
          }}
        >
          <div className="flex flex-row space-x-2">
            <span className="overflow-hidden text-sm font-medium text-ellipsis text-blue-600">
              {inviteLinkUrl.replace(/^https?:\/\//, "")}
            </span>
            {isCopyingInterviewLink ? (
              <IconCheck className="h-5 w-5 text-blue-600" />
            ) : null}
          </div>
        </Button>
      </div>
      {project.settings.interview_agent_type ===
        InterviewAgentType.GenericInterviewer && (
        <div className="mt-2 space-y-2 text-sm text-muted-foreground">
          Anyone you send this link to (via email,in-app popup, live chat, etc.)
          can complete an interview
          {project.is_live ? "" : " once this project is launched"}.{" "}
          <a
            className="text-blue-600 underline"
            href="https://help.alpharun.com/en/articles/687232"
            rel="noopener noreferrer"
            target="_blank"
          >
            Check out the guide
          </a>{" "}
          for maximizing conversion with your interview link.
        </div>
      )}
    </div>
  );
};
